import { Component } from '@angular/core';

interface Service {
  icon: 'rombo' | 'circulos' | 'sol';
  title: string;
  description: string;
  cta: string;
  ctaTarget: string;
}

@Component({
  selector: 'app-services',
  standalone: true,
  templateUrl: './services.html',
  styleUrl: './services.scss',
})
export class ServicesComponent {
  services: Service[] = [
    {
      icon: 'rombo',
      title: 'Talleres de bienestar & creatividad',
      description:
        'Cada sesión parte de una temática emocional y propone un proceso creativo guiado, accesible para cualquier persona.',
      cta: 'Próximos talleres',
      ctaTarget: 'talleres',
    },
    {
      icon: 'circulos',
      title: 'Talleres privados & personalizados',
      description:
        'Creamos talleres adaptados para grupos privados: amigos, parejas, equipos o celebraciones especiales.',
      cta: 'Organizar un taller',
      ctaTarget: 'contacto',
    },
    {
      icon: 'sol',
      title: 'Retiros creativos de bienestar emocional',
      description:
        'Los retiros están diseñados para salir del ritmo habitual, explorar con más calma y vivir un proceso creativo y personal más completo.',
      cta: 'Solicitar información',
      ctaTarget: 'contacto',
    },
  ];

  scrollTo(id: string) {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  }
}
